

import { defineComponent, ref } from 'vue';


import TimelineList from "@/views/cards/TimelineList.vue";
import TimelineItem from "@/views/cards/TimelineItem.vue";

export default defineComponent({
  name: "rotas-timeline",

  components: {
    TimelineList,
    TimelineItem
  },

  // PRIMEIRO: declare props
  props: {
    rotas: {
      type: Array as () => any[],
      default: () => []
    },
    janelas: {
      type: Array as () => string[],
      default: () => []
    },
    map: {
      type: Object,
      default: () => null
    }
  },

  // DEPOIS computed
  computed: {
    rotasFiltradas(): any[] {
      return this.rotas.filter((rota: any) => {
        const janelas_nome = [
          { value: '1', label: '08:00-10:00' },
          { value: '2', label: '10:00-12:00' },
          { value: '3', label: '12:00-14:00' },
          { value: '4', label: '14:00-16:00' },
          { value: '5', label: '16:00-18:00' },
          { value: '6', label: '18:00-20:00' },
        ];

        const intervalo = this.getIntervalo(rota);
        if (!intervalo) return false;

        const janelaEncontrada = janelas_nome.find(j => j.label === intervalo);
        if (!janelaEncontrada) return false;

        return this.janelas.includes(janelaEncontrada.value);
      });
    }
  },

  data() {
    return {
      por_pagina: false,
      isLast: false,
    };
  },

  methods: {
    getIntervalo(rota: any) {
      const match = rota.name.match(/\[(.*?)\]/);
      if (!match) return null;
      return match[1].replace("–", "-");
    },

    getIconeByStatus(status: number) {
      if (status === 0) return 'ni ni-box-2';
      if (status === 1) return 'ni ni-box-2';
      if (status === 2) return 'ni ni-check-bold';
      if (status === 5) return 'fas fa-clock';
      return 'ni ni-box-2';
    },

    getColorByStatus(status: number) {
      if (status === 0) return 'info';
      if (status === 1) return 'warning';
      if (status === 2) return 'success';
      if (status === 5) return 'danger';
      return '';
    },

    getClassByStatus(status: number) {
      if (status === 0) return 'pedido-status-desativado';
      if (status === 1) return 'pedido-status-ativo';
      if (status === 2) return 'pedido-status-concluido';
      if (status === 5) return 'pedido-status-aguardando';
      return '';
    }
  },

  setup(props) {
    const setCenter = (rota: any) => {
      if (rota?.Operacao?.latitude && rota?.Operacao?.longitude) {
        props.map?.setCenter({
          lat: parseFloat(rota.Operacao.latitude),
          lng: parseFloat(rota.Operacao.longitude),
        });
      }
    };

    const setCenterItem = (pedido: any) => {
      if (pedido?.latitude && pedido?.longitude) {
        props.map?.setCenter({
          lat: parseFloat(pedido.latitude),
          lng: parseFloat(pedido.longitude),
        });
      }
    };

    return { setCenter, setCenterItem };
  }
});
